/**
 * Partners Swiper Initialization
 * Optimized for smooth swiping performance
 */
document.addEventListener("DOMContentLoaded", function () {
  const partners = document.querySelector(".partners-swiper");
  if (!partners) return;

  new Swiper(partners, {
    loop: true,
    slidesPerView: "auto",
    centerInsufficientSlides: true,
    spaceBetween: 30,
    grabCursor: true,

    autoplay: {
      delay: 5000,
      disableOnInteraction: true,
    },

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    breakpoints: {
      1024: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
      },
    },
  });
});
